import { observer } from "mobx-react-lite";
import React from "react";
import {useHistory} from "react-router-dom";

import "./BenefitsListTableRows.scss";

import AppStore from "stores/AppStore";
import BenefitsListStore from "stores/BenefitsListStore";

const BenefitsListTableRows: React.FC = () => {
  const { benefits } = BenefitsListStore;
  const history = useHistory();
  const {
    i18n: {
      benefits: { nothingToShow }
    }
  } = AppStore;

  if (benefits.length === 0) {
    return <span>{nothingToShow}</span>
  }

  return (
    <tbody className="c-benefits-list-table-tbody">
      {benefits && benefits.map((benefit) => (
        <tr
          className="c-benefits-list-table-tbody__tr"
          key={benefit.id}
          onClick={() => {
            history.push(`/benefits/${benefit.id}`);
          }}
        >
          <td className="c-benefits-list-table-tbody__td u-align-left">{benefit.family}</td>
          <td className="c-benefits-list-table-tbody__td u-align-left">{benefit.packageName}</td>
          <td className="c-benefits-list-table-tbody__td u-align-left">{benefit.isActive ? "Yes":"No"}</td>
          <td className="c-benefits-list-table-tbody__td u-align-left">{(benefit.baseBenefit ?? false) ? "Yes":"No"}</td>
          <td className="c-benefits-list-table-tbody__td u-align-left">{benefit.price.value}</td>
        </tr>
      ))}
    </tbody>
  );
};

export default observer(BenefitsListTableRows);
